import React from 'react'
import { Container } from 'react-bootstrap'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Contect from './connectTabs/Contect';
import Internship from './connectTabs/Internship';
import Volunteer from './connectTabs/Volunteer';
import DonateNow from './connectTabs/DonateNow';
import Jobs from './connectTabs/Jobs';
import { Helmet } from "react-helmet";
import { FaInstagram } from "react-icons/fa";
import { GrFacebookOption } from "react-icons/gr";
import { ImYoutube2 } from "react-icons/im";
import SupportTab from './connectTabs/SupportTab';

const Connect = () => {
  return (
    <>
      <Helmet>
        <html lang="en" />
        <title>Muskaan - Connect</title>
        <meta name="twitter:title" content='Connect' />
        <meta name="description" content="muskaan ngo" />
        <meta name="theme-color" content="#E6E6FA" />
      </Helmet>

      {/* <div className='connect-bg fixed-bg'>
        <Container className='text-center text-white'>
          <h1>Connect</h1>
        </Container>
      </div> */}

      <div className='bgpettern pb-5 page-margin page-heigh'>
        <Container className='pt-4'>
          <h4>Connect</h4>
          <p>Home  / Connect</p>
          <div className='with_aside-border history'>
            <h5 className='mt-3'>Support Us: </h5>
            <p>At Muskaan, we believe in the transformative power of education and collective action. Since our inception in 1998,
              we've been on a journey of empowerment, working hand-in-hand with children and young people from marginalized communities, particularly the denotified tribes and marginalized groups within the urban poor. Our approach goes beyond the conventional to address the root causes of inequality, striving for a more holistic and sustainable impact.</p>
            <p><span style={{ fontWeight: "600" }}>Your Support Matters : </span>   As we continue our journey trying to create an impact, your support can make a significant difference in the lives of those who need it the most. Whether it's contributing to educational initiatives, community development projects, or addressing critical issues
              like protection of dignity and survival for our communities, every donation counts.</p>
            <h6>How can you help?</h6>
            <div className='mt-3 communication-tab'>

              <Tabs
                defaultActiveKey="two"
                id="fill-tab-example"
              // fill
              >
                {/* <Tab eventKey="one" title="Donate Now">
                  <DonateNow />
                </Tab> */}

                <Tab eventKey="two" title="Work with us">
                  <Jobs />
                </Tab>
                <Tab eventKey="five" title="Volunteer / Internship">
                  {/* <Volunteer /> */}
                  <Internship />
                </Tab>
                <Tab eventKey="tree" title="Help Spread the Word">
                  <div className='contact-social-icon text-center'>
                    <p>Raise awareness about our mission and encourage others to join the cause. Please share our webpage and social
                      media handles with anyone you think might be interested in supporting. </p>

                    <div className='pt-4'>
                      <a href="https://www.facebook.com/MuskaanBhopalNGO/" className="fa fa-facebook text-white p-2 m-1 rounded-1" style={{ background: "#3B5998" }}><GrFacebookOption /></a>
                      {/* <a href="#" className="fa fa-twitter text-white p-3 m-1" style={{ background: "#55ACEE" }}></a> */}
                      {/* <a href="https://www.instagram.com/muskaanbhopal" className="fa fa-instagram text-white p-2 m-1 rounded-1" style={{ background: "#125688" }}><FaInstagram /></a> */}
                      <a href="https://youtube.com/@muskaanbhopal" className="fa fa-youtube text-white p-2 m-1 rounded-1" style={{ background: "#bb0000" }}> <ImYoutube2 /></a>
                      <a href="https://www.instagram.com/muskaanbhopal" className="fa fa-instagram text-white p-2 m-1 rounded-1" style={{ background: "#125688" }}><FaInstagram /></a>  </div>
                  </div>
                </Tab>

                <Tab eventKey="four" title=" Buy from us">
                  {/* <Internship /> */}
                  <p className='text-center'>You can support us by purchasing and gifting our books, soaps, dairies, etc from :  <br />
                    <a href='https://store.muskaan.org/' target='_blank'>https://store.muskaan.org/</a>
                  </p>
                </Tab>
                {/* <Tab eventKey="seven" title="Support Us">
                  <SupportTab />
                </Tab> */}
                <Tab eventKey="six" title="Contact Us">
                  <Contect />
                </Tab>

              </Tabs>
            </div>
          </div>
        </Container>
      </div>

    </>
  )
}

export default Connect
